import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-read-more',
	templateUrl: './read-more.component.html',
	styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnInit {
	@Input('isAnimated') isAnimated: boolean = false;
	@Input('isOpen') isOpen: boolean = false;
	@Input('minHeight') minHeight: number = 100;
	@Input('maxHeight') maxHeight: number = 1000;

	public useMaxHeight: number;

	ngOnInit(): void {
		this.useMaxHeight = this.minHeight;
	}

	public toggleReadMore() {
		this.isOpen = !this.isOpen;
		//console.log('toggleOpen:', this.isOpen);
		this.useMaxHeight = (this.isOpen) ? this.maxHeight : this.minHeight;
	}
}
